import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { siteTypesEnum } from '../../../../helpers';
import BasePageView from '../sharedComponents/BasePageView/BasePageView';

const { COURSE, EVENT } = siteTypesEnum();

export function HighlightsView({ pageConfig: { siteType = EVENT } = {} }) {
  const { t } = useTranslation();

  return (
    <BasePageView
      title={t(siteType === COURSE ? 'course.highlights' : 'event.highlights')}
      informaPageId="highlights"
    />
  );
}

HighlightsView.propTypes = {
  pageConfig: PropTypes.shape({
    siteType: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  return {
    pageConfig: state.pageConfig,
  };
}

export default connect(mapStateToProps)(HighlightsView);
